import { render, staticRenderFns } from "./EditStagingEmas.vue?vue&type=template&id=2270e140&"
import script from "./EditStagingEmas.vue?vue&type=script&lang=js&"
export * from "./EditStagingEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports